import queryString from 'query-string';

import { marketingService } from './marketing.instance';
import type { GetUserCohortPayload, GetUserCohortsResponse } from './marketing-cohorts.interface';

export const getUserCohorts = async (payload?: GetUserCohortPayload) => {
  const query = payload ? queryString.stringify(payload) : '';

  const response = await marketingService.get<GetUserCohortsResponse>(
    `/cohort-memberships${query ? `?${query}` : ''}`
  );

  return response.data.data?.map((cohort) => cohort.cohortKey) || [];
};

export const updateUserCohort = async (cohortKey: string) => {
  const response = await marketingService.patch(
    `/cohort-memberships/${cohortKey}`
  );
  return response.data;
};
